var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"elementRef",class:['relative', _vm.isLoadingPortraitMobileLayout && 'mb-9']},[_c(_setup.OzBaseButton,{ref:"buttonRef",class:[
      'p-0',
      'overflow-hidden',

      {
        'w-[69px] h-10': !_vm.isLoadingPortraitMobileLayout, // 72px - 3px for ring (not included in border-box)
        'w-[96px] h-13.5': _vm.isLoadingPortraitMobileLayout,
      },
      'box-border',
      'shrink-0',
      'group',
      {
        'animate-pulse-bg-color pulse-bg-from-white pulse-bg-to-grey-200': _setup.isDragging,
      },
      'text-dark-text-100',
      'rounded-md',
      'hfocus-visible:ring-3 hfocus-visible:ring-offset-2',
      {
        'bg-light-ui-100': _vm.currentFrameId === _vm.frameId,
        'bg-light-ui-200': _vm.currentFrameId !== _vm.frameId,
        'ring-2 ring-offset-0 ring-grey-200': _vm.colorScheme === 'light',
        'hfocus-visible:ring-offset-light-ui-100 hfocus-visible:ring-grape-500': _vm.colorScheme === 'light',
        'hfocus-visible:ring-offset-dark-ui-100  hfocus-visible:ring-canary-500': _vm.colorScheme === 'dark',
      },
      'transform-gpu',
      'duration-150',
    ],on:{"click":function($event){return _setup.switchFrame(_vm.frameId)},"contextmenu":function($event){$event.preventDefault();return _setup.showContextMenu($event, _vm.frameId)}}},[_c('div',{class:[
        'absolute',
        'top-0',
        'start-0',

        'text-body-small',
        'font-semibold',
        'h-6',
        'w-6',
        'rounded-ee-lg',
        'z-10',
        'flex justify-center items-center',
        {
          'bg-dark-ui-200 text-light-text-200 hover-hover:group-hover:text-light-text-100':
            _vm.currentFrameId !== _vm.frameId && _vm.colorScheme === 'dark',
          'bg-canary-500 text-dark-text-100': _vm.currentFrameId === _vm.frameId && _vm.colorScheme === 'dark',
          'bg-light-ui-100 text-dark-text-200 hover-hover:group-hover:text-dark-text-100':
            _vm.currentFrameId !== _vm.frameId && _vm.colorScheme === 'light',
          'bg-grape-500 text-light-text-100': _vm.currentFrameId === _vm.frameId && _vm.colorScheme === 'light',
        },
      ]},[_vm._v("\n      "+_vm._s(_vm.frameIndex)+"\n    ")]),_vm._v(" "),_c('div',{class:[
        'bg-contain w-full h-full transition-all duration-300 ease-in-out frame-preview pointer-events-none',
        {
          'opacity-80 hover-hover:group-hover:opacity-100': _vm.currentFrameId !== _vm.frameId && _vm.colorScheme === 'dark',
          'opacity-50 hover-hover:group-hover:opacity-100': _vm.currentFrameId !== _vm.frameId && _vm.colorScheme === 'light',
        },
      ],domProps:{"innerHTML":_vm._s(_vm.previewHtml)}})]),_vm._v(" "),_c(_setup.OzPlainButton,{class:[
      'absolute',
      {
        'top-0 end-[-18px]': !_vm.isLoadingPortraitMobileLayout,
        '-bottom-9 start-1/2 -translate-x-2/4 h-6 w-6': _vm.isLoadingPortraitMobileLayout,
      },

      // Increase click area
      'p-0 pb-1',
      // 'py-2 pe-1 ps-0',

      // Focus
      'hfocus-visible:ring-3',
      'rounded-sm hfocus-visible:pb-0',
      _vm.colorScheme === 'light' && 'hfocus-visible:ring-grape-500',
      _vm.colorScheme === 'dark' && 'hfocus-visible:ring-canary-500',
    ],attrs:{"color-scheme":_setup.OzPlainButtonColorScheme.SecondaryIcon,"size-preset":_setup.OzPlainButtonSizePreset.Bare,"dark-mode":_vm.colorScheme === 'dark',"aria-label":_vm.__('More card actions'),"title":_vm.__('More card actions')},on:{"click":function($event){return _setup.showContextMenu($event, _vm.frameId)}}},[_c(_setup.OzIcon,{class:{ 'rotate-90': _vm.isLoadingPortraitMobileLayout },attrs:{"name":"more_vertical_thin","size":_vm.isLoadingPortraitMobileLayout ? 24 : 16}})],1),_vm._v(" "),(_setup.closestEdgeToPointer)?_c(_setup.OzDropIndicatorLine,{attrs:{"edge":_setup.closestEdgeToPointer,"gap":_vm.isLoadingPortraitMobileLayout ? 6 : 12,"dark-mode":_vm.colorScheme === 'dark'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }